import UsersTable from './components/UsersTable';
import VolumeWidget from 'components/widget/VolumeWidget';
import { useVolumeStore } from 'views/store/useVolumeStore';

const UsersByVolume = () => {
  const { appVolumes } = useVolumeStore();

  return (
    <div>
      <div className="mt-3 w-full flex md:flex-row gap-4 items-center">
        <div className="w-fit">
          <VolumeWidget title="App volume" data={appVolumes} />
        </div>
      </div>
      <div className="mt-5 grid grid-cols-1 gap-5">
        <div className="w-full">
          <UsersTable />
        </div>
      </div>
    </div>
  );
};

export default UsersByVolume;
